import { defineMessages } from 'react-intl'

export const buttonMessages = defineMessages({
  back: {
    defaultMessage: 'Back',
    description: 'button',
  },
  cancel: {
    defaultMessage: 'Cancel',
    description: 'button',
  },
  clear: {
    defaultMessage: 'Clear',
    description: 'button',
  },
  confirm: {
    defaultMessage: 'Confirm',
    description: 'button',
  },
  create: {
    defaultMessage: 'Create',
    description: 'button',
  },
  delete: {
    defaultMessage: 'Delete',
    description: 'button',
  },
  done: {
    defaultMessage: 'Done',
    description: 'button',
  },
  edit: {
    defaultMessage: 'Edit',
    description: 'button',
  },
  ok: {
    defaultMessage: 'OK',
    description: 'button',
  },
  save: {
    defaultMessage: 'Save',
    description: 'button',
  },
  send: {
    defaultMessage: 'Send',
    description: 'button',
  },
})
